import { Linking, Platform } from 'react-native';

async function openBookApp(bookId?: string) {
	const INSTALLED_BOOK_APP_URL = 'com.pletly.pletlybook://';

	const hasBookAppInstalled = await Linking.canOpenURL(INSTALLED_BOOK_APP_URL);
	if (!hasBookAppInstalled) {
		return openBookAppStoreLink();
	}

	return Linking.openURL(
		bookId ? `${INSTALLED_BOOK_APP_URL}books/book?id=${bookId}` : INSTALLED_BOOK_APP_URL,
	);
}

function openBookAppStoreLink() {
	const appStoreUrl = getBookAppStoreUrl();

	return appStoreUrl && Linking.openURL(appStoreUrl);
}

function getBookAppStoreUrl() {
	const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.pletly.pletlybook';
	const IOS_APP_URL = 'https://apps.apple.com/us/app/pletly-book/id6443569036';

	if (Platform.OS === 'android') {
		return ANDROID_APP_URL;
	}

	if (Platform.OS === 'ios') {
		return IOS_APP_URL;
	}
}

export { openBookApp };
